const initialState = false;

const clickDetection = (state = initialState, action) => {
    switch (action.type) {
        case "DETECTION":
            return (state = action.payload);
        default:
            return state;
    }
};

export default clickDetection;
